import { put } from 'redux-saga/effects';

import { store } from '../store';
import { send } from '../../helpers/requests';
import * as actions from './actions';

import { DimensionsResponse } from '../../types/redux/stores/dimensions.types';
import { selectToken } from '../selectors';

export function* getDimensionsRequestSaga() {
  try {
    const res: DimensionsResponse['res'] = yield send({
      url: `/dimensions`,
      method: 'GET',
      token: selectToken(store.getState()),
    });
    yield put(actions.getDimensionsRequestSuccess({ res }));
  } catch (error) {
    yield put(actions.getDimensionsRequestFailure(error));
  }
}
